<form class="dismiss-influencer-form" (ngSubmit)="onDismiss()" (keyup)="onKeyDown($event)">
  <h3 class="title">{{'pending_influencer.dismiss_title' | translate}}</h3>
  <div class="content">
    <span>{{'pending_influencer.dismiss_msg' | translate}}</span>
    <div class="reason-selection">
      <achoo-filter-box #dismissReason
                        [placeholder]="'pending_influencer.select_reason' | translate"
                        [makeSelectedItemOnTop]="false"
                        [options]="dismissReasons"
                        [(model)]="selectedDismissReason"
                        (selectEvent)="onSelectReason()"></achoo-filter-box>
    </div>
  </div>
  <div class="action-btn">
    <button class="button gray" (click)="closePopup()">{{'common.btn.cancel' | translate}}</button>
    <button class="button blue" (click)="onDismiss()">{{'common.btn.continue' | translate}}</button>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/main/admin/influencer-review/dismiss-influencer-popup/dismiss-influencer-popup.component.html